import { computed, inject, signal } from "@angular/core"
import { OrderStateServiceWrapper } from "../store/state/order/order.state.wrapper.service"
import { ServiceAvailabilityResponse } from "../models/order/api-models/order-sq-response.model";
import { VideoPackageTypeEnum } from "../enums/video-package-type.enum";
import { isVoiceProductType, PRODUCT_TYPES } from "../models/order/order.model";
import { FeatureFlagService } from "./feature-flag.service";
import { AppStateService } from "../store/state/app/app.state.service";
import { OrderApiResponseStateService } from "../store/state/order/orderv2/order-api-response/order-api-response-state.service";
import { OrderStateApiBridgeService } from "../store/state/order/orderv2/order-state-api-bridge.service";
import { OrderStateServiceV2 } from "../store/state/order/orderv2/order-state.service";
import { InternetPackageSelectionStateService } from "../store/state/order/orderv2/workflows/internet/internet-package-selection/internet-package-selection-state.service";
import { ServiceInformationCollectionStateService } from "../store/state/order/orderv2/workflows/service-info-collection/service-info-collection-state.service";
import { WirelessSetupStateService } from "../store/state/order/orderv2/workflows/wireless/wireless-setup.state.service";
import { UserStateService } from "../store/state/user/user.state.service";
import { DataService } from "./data.service";
import { EncryptDecryptService } from "./encrypt-decrypt.service";
import { EnvironmentService } from "./environment.service";
import { OrderService } from "./order/order.service";
import { OrderSetupStateService } from "../store/state/order/orderv2/workflows/order-setup/order-setup-state.service"

export class LicBaseService {
    orderService = inject(OrderService)
    appStateService = inject(AppStateService)
    userStateService = inject(UserStateService);
    encryptDecryptService = inject(EncryptDecryptService);
    serviceInformationCollectionStateService = inject(ServiceInformationCollectionStateService)
    internetPackageSelectionStateService = inject(InternetPackageSelectionStateService)
    wirelessSetupStateService = inject(WirelessSetupStateService)
    environmentService = inject(EnvironmentService);
    dataService = inject(DataService);
    orderApiResponseStateService = inject(OrderApiResponseStateService)
    orderStateApiBridgeService = inject(OrderStateApiBridgeService)
    processLaunchContextUrl = this.environmentService.getUrl('lic/launchcontext/')
    orderStateServiceV2 = inject(OrderStateServiceV2);
    orderStateService = inject(OrderStateServiceWrapper)
    availableServices = signal<ServiceAvailabilityResponse>(null);
    featureFlagService = inject(FeatureFlagService)

    productResponse = computed(() => {
        return this.availableServices()?.Response?.ProductResponse
    })

    isVideoAvailable = computed(() => {
        return this.isDtvAvailable() || this.isAtvAvailable()
    })

    // The launch's order setup overrides the preorder default (see LicService.processOrderSetupByDefaults)
    isSMB = inject(OrderSetupStateService).isSMB

    isInternetAvailable = computed(() => {
        return this.productResponse()?.some((item) => item.Type === PRODUCT_TYPES.INTERNET)
    })
    
    isDtvAvailable = computed(() => {
        return this.productResponse()?.some((item) => item.Type === VideoPackageTypeEnum.DTV && item.Code !== '2005')
    })

    isAtvAvailable = computed(() => {
        return this.productResponse()?.some((item) => item.Type === VideoPackageTypeEnum.ATV && item.Code !== '2005')
    })

     videoData = computed(() => {
        return this.availableServices()?.Components?.Component?.filter((item) => item.Category.toLowerCase() === PRODUCT_TYPES.VIDEO.toLowerCase()).sort((a, b) => (Number(a.SequenceNumber) || 0) - (Number(b.SequenceNumber) || 0))
    })

    videoProductBlocked = computed(() => {
        return this.productResponse()?.find((item) => (item.Type === VideoPackageTypeEnum.ATV || item.Type === VideoPackageTypeEnum.DTV) && item.Code === '2009' && !this.videoData()?.length)
    })

    internetData = computed(() => {
        return this.availableServices()?.Components?.Component?.filter((item) => item.Category.toLowerCase() === PRODUCT_TYPES.INTERNET.toLowerCase())
    })

    internetProductBlocked = computed(() => {
        return this.productResponse()?.find((item) => item.Type === PRODUCT_TYPES.INTERNET && item.Code === '2009' && !this.internetData()?.length)
    })


    isVoiceAvailable = computed(() => {
        return this.productResponse()?.some((item) => isVoiceProductType(item.Type) && item.Code !== '2005') && this.featureFlagService.isVoiceFlowEnabled()
    })

}